import React from 'react';

function MyPDFViewer() {
  return (
    <div>
      <h3 className='pt-5' style={{textAlign: "center"}}>Celebrating its 50th anniversary, IMD
International Search Group<br></br> launched its
first global research: ‘Leading in a
World with Changing Expectations and
New Working Cultures.</h3>
      <p style={{textAlign: "center"}}>
        <a href="../assets/img/pdf/pdf.pdf" target="_blank" rel="noopener noreferrer">Show Information</a>
      </p>
    </div>
  );
}

export default MyPDFViewer;